import { Tables } from "@/lib/supabase/supabase_types_override";
import { supabase } from "@/lib/supabase/supabaseClient";

export const deleteQuestionBankQuestion = async (id: Tables<'question_bank'>['id']) => await supabase.from('question_bank').delete().eq('id', id).throwOnError();